var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.383,17.51H31.617c-1.104,0-2,0.896-2,2v56.979c0,1.104,0.896,2,2,2h32.766c1.104,0,2-0.896,2-2V19.51 C66.383,18.406,65.487,17.51,64.383,17.51z M62.383,74.489H33.617v-4.757h28.766V74.489z M62.383,65.732H33.617V21.51h28.766 V65.732z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.294,28.229h9.412c1.104,0,2-0.896,2-2s-0.896-2-2-2h-9.412c-1.104,0-2,0.896-2,2S42.189,28.229,43.294,28.229z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone1);
export default __webpack_public_path__ + "static/media/phone-1.b39ca7ea55d0ba0dc0706b94547cd276.svg";
export { ForwardRef as ReactComponent };